var _g, _path, _g2, _path2, _rect, _path3, _circle, _g3, _g4, _rect2, _path4, _circle2, _g5, _g6, _rect3, _path5, _rect4, _rect5, _rect6, _rect7, _circle3, _path6, _g7, _circle4, _rect8, _path7, _circle5, _g8, _g9, _path8, _line, _rect9, _path9, _rect0, _rect1, _rect10, _circle6, _path0, _g0, _circle7, _circle8, _path1, _path10, _path11, _path12, _path13, _g1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZeroStateGraphRu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1653 1004",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddddd_31_2308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M861.5 548V820C861.5 821.933 859.933 823.5 858 823.5H565C563.067 823.5 561.5 821.933 561.5 820V548C561.5 546.067 563.067 544.5 565 544.5H694.958C695.903 544.5 696.824 544.202 697.59 543.65L709.452 535.093C710.675 534.212 712.325 534.212 713.548 535.093L725.41 543.65C726.176 544.202 727.097 544.5 728.042 544.5H858C859.933 544.5 861.5 546.067 861.5 548Z",
    fill: "#23262D",
    stroke: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585,
    y: 579,
    width: 21.1794,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.428,
    y: 579,
    width: 79.9351,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 707.294,
    y: 579,
    width: 56.7061,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_2308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 585,
    y: 708,
    width: 46.2595,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.68,
    y: 708,
    width: 140.321,
    height: 20,
    rx: 10,
    fill: "#404648"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 700.42,
    y: 766,
    width: 124.58,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585,
    y: 766,
    width: 100.763,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 561,
    y: 622,
    width: 301,
    height: 60,
    fill: "#C4C4C4",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.735 668.263V659.772H587.195C587.685 659.381 588.143 658.831 588.569 658.121C588.995 657.411 589.357 656.437 589.656 655.202C589.954 653.966 590.16 652.368 590.273 650.408L590.849 641.182H604.794V659.772H607.223V668.241H603.43V663H589.528V668.263H585.735ZM591.797 659.772H601.001V644.495H594.407L594.066 650.408C593.974 651.892 593.825 653.22 593.619 654.392C593.413 655.564 593.153 656.597 592.841 657.492C592.528 658.38 592.18 659.14 591.797 659.772ZM617.41 663.32C615.812 663.32 614.427 662.968 613.256 662.265C612.084 661.562 611.175 660.578 610.528 659.314C609.889 658.05 609.569 656.572 609.569 654.882C609.569 653.192 609.889 651.711 610.528 650.44C611.175 649.168 612.084 648.181 613.256 647.478C614.427 646.775 615.812 646.423 617.41 646.423C619.008 646.423 620.393 646.775 621.565 647.478C622.737 648.181 623.643 649.168 624.282 650.44C624.928 651.711 625.251 653.192 625.251 654.882C625.251 656.572 624.928 658.05 624.282 659.314C623.643 660.578 622.737 661.562 621.565 662.265C620.393 662.968 619.008 663.32 617.41 663.32ZM617.432 660.23C618.298 660.23 619.023 659.992 619.605 659.516C620.187 659.033 620.621 658.387 620.905 657.577C621.196 656.768 621.341 655.866 621.341 654.871C621.341 653.87 621.196 652.964 620.905 652.155C620.621 651.338 620.187 650.688 619.605 650.205C619.023 649.722 618.298 649.481 617.432 649.481C616.544 649.481 615.805 649.722 615.216 650.205C614.633 650.688 614.197 651.338 613.905 652.155C613.621 652.964 613.479 653.87 613.479 654.871C613.479 655.866 613.621 656.768 613.905 657.577C614.197 658.387 614.633 659.033 615.216 659.516C615.805 659.992 616.544 660.23 617.432 660.23ZM641.639 640.585L642.981 643.078C642.505 643.49 641.973 643.788 641.383 643.973C640.794 644.158 640.101 644.278 639.306 644.335C638.517 644.385 637.58 644.42 636.493 644.442C635.272 644.47 634.274 644.701 633.5 645.134C632.725 645.567 632.132 646.224 631.721 647.105C631.309 647.979 631.039 649.094 630.911 650.45H631.092C631.603 649.449 632.321 648.685 633.244 648.16C634.167 647.634 635.25 647.371 636.493 647.371C637.85 647.371 639.047 647.677 640.083 648.288C641.127 648.891 641.941 649.768 642.523 650.919C643.113 652.07 643.407 653.462 643.407 655.095C643.407 656.778 643.091 658.238 642.459 659.474C641.827 660.702 640.929 661.651 639.764 662.318C638.606 662.986 637.232 663.32 635.641 663.32C634.057 663.32 632.679 662.975 631.507 662.286C630.343 661.59 629.441 660.564 628.801 659.207C628.169 657.844 627.853 656.164 627.853 654.168V652.698C627.853 648.849 628.571 645.976 630.005 644.08C631.44 642.183 633.567 641.217 636.387 641.182C637.225 641.168 637.974 641.164 638.635 641.171C639.302 641.178 639.885 641.146 640.382 641.075C640.879 641.004 641.298 640.841 641.639 640.585ZM635.662 660.23C636.451 660.23 637.132 660.028 637.708 659.623C638.283 659.211 638.723 658.629 639.029 657.876C639.341 657.123 639.498 656.232 639.498 655.202C639.498 654.186 639.341 653.323 639.029 652.613C638.716 651.896 638.272 651.349 637.697 650.972C637.122 650.596 636.436 650.408 635.641 650.408C635.044 650.408 634.508 650.514 634.032 650.727C633.556 650.94 633.152 651.253 632.818 651.665C632.484 652.077 632.228 652.577 632.051 653.167C631.873 653.756 631.777 654.435 631.763 655.202C631.763 656.743 632.111 657.968 632.807 658.877C633.503 659.779 634.455 660.23 635.662 660.23ZM651.397 663.33C650.36 663.33 649.426 663.146 648.596 662.776C647.772 662.4 647.118 661.846 646.635 661.114C646.159 660.383 645.922 659.481 645.922 658.408C645.922 657.485 646.092 656.722 646.433 656.118C646.774 655.514 647.239 655.031 647.828 654.669C648.418 654.307 649.082 654.033 649.821 653.849C650.566 653.657 651.337 653.518 652.132 653.433C653.091 653.334 653.869 653.245 654.466 653.167C655.062 653.082 655.495 652.954 655.765 652.783C656.042 652.606 656.181 652.332 656.181 651.963V651.899C656.181 651.097 655.943 650.475 655.467 650.035C654.991 649.594 654.306 649.374 653.411 649.374C652.466 649.374 651.717 649.58 651.163 649.992C650.616 650.404 650.247 650.891 650.055 651.452L646.454 650.94C646.738 649.946 647.207 649.115 647.86 648.447C648.514 647.773 649.313 647.268 650.257 646.935C651.202 646.594 652.246 646.423 653.39 646.423C654.178 646.423 654.963 646.516 655.744 646.7C656.525 646.885 657.239 647.19 657.885 647.616C658.532 648.036 659.05 648.607 659.441 649.332C659.838 650.056 660.037 650.962 660.037 652.048V663H656.33V660.752H656.202C655.968 661.207 655.637 661.633 655.211 662.031C654.792 662.421 654.263 662.737 653.624 662.979C652.992 663.213 652.25 663.33 651.397 663.33ZM652.399 660.496C653.173 660.496 653.844 660.344 654.412 660.038C654.98 659.726 655.417 659.314 655.723 658.803C656.035 658.291 656.191 657.734 656.191 657.13V655.202C656.071 655.301 655.865 655.393 655.574 655.479C655.289 655.564 654.97 655.638 654.615 655.702C654.26 655.766 653.908 655.823 653.56 655.873C653.212 655.923 652.91 655.965 652.654 656.001C652.079 656.079 651.564 656.207 651.11 656.384C650.655 656.562 650.297 656.81 650.034 657.13C649.771 657.442 649.64 657.847 649.64 658.344C649.64 659.055 649.899 659.591 650.417 659.953C650.936 660.315 651.596 660.496 652.399 660.496ZM663.915 663V646.636H670.787C672.725 646.636 674.256 647.023 675.378 647.798C676.507 648.572 677.072 649.651 677.072 651.036C677.072 651.952 676.752 652.702 676.113 653.284C675.481 653.859 674.618 654.246 673.525 654.445C674.384 654.516 675.137 654.733 675.783 655.095C676.436 655.457 676.948 655.933 677.317 656.523C677.686 657.112 677.871 657.79 677.871 658.558C677.871 659.46 677.633 660.244 677.157 660.912C676.689 661.572 676.003 662.087 675.101 662.457C674.206 662.819 673.12 663 671.841 663H663.915ZM667.527 659.964H671.841C672.551 659.964 673.109 659.797 673.514 659.463C673.919 659.122 674.121 658.661 674.121 658.078C674.121 657.403 673.919 656.874 673.514 656.491C673.109 656.1 672.551 655.905 671.841 655.905H667.527V659.964ZM667.527 653.412H670.861C671.387 653.412 671.838 653.337 672.214 653.188C672.591 653.032 672.878 652.815 673.077 652.538C673.276 652.254 673.375 651.917 673.375 651.526C673.375 650.965 673.145 650.525 672.683 650.205C672.228 649.886 671.596 649.726 670.787 649.726H667.527V653.412ZM684.772 657.78L691.324 646.636H695.287V663H691.558V651.846L685.028 663H681.054V646.636H684.772V657.78ZM697.415 649.8V646.636H711.733V649.8H706.438V663H702.71V649.8H697.415ZM717.414 651.963H722.24C724.328 651.963 725.944 652.471 727.087 653.487C728.231 654.502 728.806 655.834 728.813 657.482C728.806 658.554 728.543 659.506 728.025 660.337C727.513 661.168 726.768 661.821 725.787 662.297C724.814 662.766 723.632 663 722.24 663H714.804V646.636H718.522V659.836H722.24C723.078 659.836 723.767 659.623 724.307 659.197C724.846 658.763 725.116 658.21 725.116 657.535C725.116 656.825 724.846 656.246 724.307 655.798C723.767 655.351 723.078 655.127 722.24 655.127H717.414V651.963ZM739.56 663V646.636H746.431C748.37 646.636 749.901 647.023 751.023 647.798C752.152 648.572 752.717 649.651 752.717 651.036C752.717 651.952 752.397 652.702 751.758 653.284C751.126 653.859 750.263 654.246 749.169 654.445C750.028 654.516 750.781 654.733 751.428 655.095C752.081 655.457 752.592 655.933 752.962 656.523C753.331 657.112 753.516 657.79 753.516 658.558C753.516 659.46 753.278 660.244 752.802 660.912C752.333 661.572 751.648 662.087 750.746 662.457C749.851 662.819 748.764 663 747.486 663H739.56ZM743.171 659.964H747.486C748.196 659.964 748.754 659.797 749.158 659.463C749.563 659.122 749.766 658.661 749.766 658.078C749.766 657.403 749.563 656.874 749.158 656.491C748.754 656.1 748.196 655.905 747.486 655.905H743.171V659.964ZM743.171 653.412H746.506C747.031 653.412 747.482 653.337 747.859 653.188C748.235 653.032 748.523 652.815 748.722 652.538C748.92 652.254 749.02 651.917 749.02 651.526C749.02 650.965 748.789 650.525 748.327 650.205C747.873 649.886 747.241 649.726 746.431 649.726H743.171V653.412ZM773.557 658.515L778.415 646.636H781.526L774.91 663H772.215L765.748 646.636H768.827L773.557 658.515ZM767.858 646.636V663H764.14V646.636H767.858ZM779.417 663V646.636H783.103V663H779.417ZM790.709 657.78L797.261 646.636H801.224V663H797.496V651.846L790.965 663H786.991V646.636H790.709V657.78ZM805.185 663V646.636H809.041V653.241H810.447L815.369 646.636H820.014L813.952 654.669L820.078 663H815.412L810.927 656.832H809.041V663H805.185ZM828.729 663.32C827.095 663.32 825.692 662.961 824.521 662.244C823.356 661.526 822.457 660.536 821.825 659.271C821.2 658 820.888 656.537 820.888 654.882C820.888 653.22 821.207 651.754 821.847 650.482C822.486 649.204 823.388 648.21 824.553 647.499C825.724 646.782 827.109 646.423 828.707 646.423C830.036 646.423 831.211 646.668 832.234 647.158C833.263 647.641 834.084 648.327 834.695 649.214C835.305 650.095 835.653 651.125 835.739 652.304H832.053C831.903 651.516 831.548 650.859 830.987 650.333C830.433 649.8 829.691 649.534 828.761 649.534C827.972 649.534 827.28 649.747 826.683 650.173C826.087 650.592 825.621 651.196 825.288 651.984C824.961 652.773 824.798 653.717 824.798 654.818C824.798 655.933 824.961 656.892 825.288 657.695C825.614 658.49 826.072 659.104 826.662 659.538C827.259 659.964 827.958 660.177 828.761 660.177C829.329 660.177 829.837 660.07 830.284 659.857C830.739 659.637 831.119 659.321 831.424 658.909C831.729 658.497 831.939 657.996 832.053 657.407H835.739C835.646 658.565 835.305 659.591 834.716 660.486C834.126 661.374 833.324 662.07 832.308 662.574C831.293 663.071 830.099 663.32 828.729 663.32Z",
    fill: "#35FFD0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_31_2308",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 76,
    width: 751,
    height: 443
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 76H751L631 519H0V76Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_31_2308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 75.7744,
    width: 391,
    height: 86,
    rx: 10,
    fill: "#2F2F30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 118.774,
    r: 25,
    fill: "#49494B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 128.108C40 125.162 43.5817 122.774 48 122.774C52.4183 122.774 56 125.162 56 128.108",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0003 118.774C50.9458 118.774 53.3337 116.386 53.3337 113.441C53.3337 110.495 50.9458 108.107 48.0003 108.107C45.0548 108.107 42.667 110.495 42.667 113.441C42.667 116.386 45.0548 118.774 48.0003 118.774Z",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392,
    cy: 118.774,
    r: 17,
    fill: "#2F2F30",
    stroke: "#181818",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_31_2308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 108.774,
    width: 262,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 508,
    y: 75.7744,
    width: 391,
    height: 86,
    rx: 10,
    fill: "#2F2F30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 555,
    cy: 118.774,
    r: 25,
    fill: "#49494B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 128.108C547 125.162 550.582 122.774 555 122.774C559.418 122.774 563 125.162 563 128.108",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 118.774C557.946 118.774 560.334 116.386 560.334 113.441C560.334 110.495 557.946 108.107 555 108.107C552.055 108.107 549.667 110.495 549.667 113.441C549.667 116.386 552.055 118.774 555 118.774Z",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_31_2308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 108.774,
    width: 60,
    height: 20,
    rx: 10,
    fill: "#959598"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 108.774,
    width: 182,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 508,
    y: 194.774,
    width: 391,
    height: 86,
    rx: 10,
    fill: "#2F2F30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 555,
    cy: 237.774,
    r: 25,
    fill: "#49494B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 247.108C547 244.162 550.582 241.774 555 241.774C559.418 241.774 563 244.162 563 247.108",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 237.774C557.946 237.774 560.334 235.386 560.334 232.441C560.334 229.495 557.946 227.107 555 227.107C552.055 227.107 549.667 229.495 549.667 232.441C549.667 235.386 552.055 237.774 555 237.774Z",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_31_2308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 227.774,
    width: 31,
    height: 20,
    rx: 10,
    fill: "#959598"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646,
    y: 227.774,
    width: 117,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 508,
    y: 313.774,
    width: 391,
    height: 86,
    rx: 10,
    fill: "#2F2F30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 555,
    cy: 356.774,
    r: 25,
    fill: "#49494B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 366.108C547 363.162 550.582 360.774 555 360.774C559.418 360.774 563 363.162 563 366.108",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 356.774C557.946 356.774 560.334 354.386 560.334 351.441C560.334 348.495 557.946 346.107 555 346.107C552.055 346.107 549.667 348.495 549.667 351.441C549.667 354.386 552.055 356.774 555 356.774Z",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_31_2308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 726,
    y: 346.774,
    width: 136,
    height: 20,
    rx: 10,
    fill: "#959598"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 346.774,
    width: 110,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 508,
    y: 432.774,
    width: 391,
    height: 86,
    rx: 10,
    fill: "#2F2F30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 555,
    cy: 475.774,
    r: 25,
    fill: "#49494B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 485.108C547 482.162 550.582 479.774 555 479.774C559.418 479.774 563 482.162 563 485.108",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 475.774C557.946 475.774 560.334 473.386 560.334 470.441C560.334 467.495 557.946 465.107 555 465.107C552.055 465.107 549.667 467.495 549.667 470.441C549.667 473.386 552.055 475.774 555 475.774Z",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_31_2308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 465.774,
    width: 262,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M509 237.774C448.535 238.523 450.117 117.77 392 118.491",
    stroke: "#2F2F30",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509 356.774C451.672 355.832 447.101 119.395 392 118.491",
    stroke: "#2F2F30",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 475.774C456.635 473.224 446.176 120.94 392 118.491",
    stroke: "#2F2F30",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 396,
    y1: 118.774,
    x2: 508,
    y2: 118.774,
    stroke: "#2F2F30",
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_31_2308",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 671,
    y: 76,
    width: 752,
    height: 443
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M791 76H1423V519H671L791 76Z",
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_31_2308)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 546,
    y: 75.7744,
    width: 391,
    height: 147,
    rx: 10,
    fill: "#2F2F30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M546 85.7744C546 80.2516 550.477 75.7744 556 75.7744H693V222.774H556C550.477 222.774 546 218.297 546 212.774V85.7744Z",
    fill: "#858585"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 937,
    cy: 149.774,
    r: 17,
    fill: "#2F2F30",
    stroke: "#181818",
    strokeWidth: 7
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_31_2308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 95.7744,
    width: 179,
    height: 20,
    rx: 10,
    fill: "#959598"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_31_2308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 129.774,
    width: 21.1794,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 749.428,
    y: 129.774,
    width: 79.9351,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840.294,
    y: 129.774,
    width: 56.7061,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 546,
    y: 255.774,
    width: 391,
    height: 147,
    rx: 10,
    fill: "#2F2F30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M546 265.774C546 260.252 550.477 255.774 556 255.774H693V402.774H556C550.477 402.774 546 398.297 546 392.774V265.774Z",
    fill: "#858585"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 937,
    cy: 329.774,
    r: 17,
    fill: "#2F2F30",
    stroke: "#181818",
    strokeWidth: 7
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_31_2308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 275.774,
    width: 179,
    height: 20,
    rx: 10,
    fill: "#959598"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_31_2308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 804.084,
    y: 309.774,
    width: 92.916,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 309.774,
    width: 75.1527,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1061,
    y: 76,
    width: 391,
    height: 147,
    rx: 10,
    fill: "#2F2F30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1061 86C1061 80.4772 1065.48 76 1071 76H1208V223H1071C1065.48 223 1061 218.523 1061 213V86Z",
    fill: "#525252"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1233,
    y: 96,
    width: 179,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1233,
    y: 130,
    width: 21.1794,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1264.43,
    y: 130,
    width: 79.9351,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1355.29,
    y: 130,
    width: 56.7061,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1134.5,
    cy: 149.5,
    r: 27,
    stroke: "#999999",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_31_2308",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1113,
    y: 127,
    width: 22,
    height: 23
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1119.5 132.5L1113.5 140.5L1134.5 149.5L1133.5 127L1119.5 132.5Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_31_2308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1134.5 166C1143.61 166 1151 158.613 1151 149.5C1151 140.387 1143.61 133 1134.5 133C1125.39 133 1118 140.387 1118 149.5C1118 158.613 1125.39 166 1134.5 166ZM1134.5 169C1145.27 169 1154 160.27 1154 149.5C1154 138.73 1145.27 130 1134.5 130C1123.73 130 1115 138.73 1115 149.5C1115 160.27 1123.73 169 1134.5 169Z",
    fill: "#999999"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1135,
    cy: 150,
    r: 4.5,
    stroke: "#999999",
    strokeWidth: 3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 546,
    y: 435.774,
    width: 391,
    height: 147,
    rx: 10,
    fill: "#2F2F30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M546 445.774C546 440.252 550.477 435.774 556 435.774H693V582.774H556C550.477 582.774 546 578.297 546 572.774V445.774Z",
    fill: "#858585"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 937,
    cy: 509.774,
    r: 17,
    fill: "#2F2F30",
    stroke: "#181818",
    strokeWidth: 7
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_31_2308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 455.774,
    width: 179,
    height: 20,
    rx: 10,
    fill: "#959598"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_31_2308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 489.774,
    width: 21.1794,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 749.428,
    y: 489.774,
    width: 79.9351,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840.294,
    y: 489.774,
    width: 56.7061,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1061 334.527C1003.67 333.585 999.101 153.148 944 152.244",
    stroke: "#2F2F30",
    strokeWidth: 6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 948,
    y1: 149,
    x2: 1060,
    y2: 149,
    stroke: "#2F2F30",
    strokeWidth: 6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1061,
    y: 256,
    width: 391,
    height: 147,
    rx: 10,
    fill: "#2F2F30"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1061 266C1061 260.477 1065.48 256 1071 256H1208V403H1071C1065.48 403 1061 398.523 1061 393V266Z",
    fill: "#525252"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 1233,
    y: 276,
    width: 179,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 1319.08,
    y: 310,
    width: 92.916,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1233,
    y: 310,
    width: 75.1527,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1134.5,
    cy: 329.5,
    r: 27,
    stroke: "#999999",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_31_2308",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1113,
    y: 307,
    width: 22,
    height: 23
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1119.5 312.5L1113.5 320.5L1134.5 329.5L1133.5 307L1119.5 312.5Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_31_2308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1134.5 346C1143.61 346 1151 338.613 1151 329.5C1151 320.387 1143.61 313 1134.5 313C1125.39 313 1118 320.387 1118 329.5C1118 338.613 1125.39 346 1134.5 346ZM1134.5 349C1145.27 349 1154 340.27 1154 329.5C1154 318.73 1145.27 310 1134.5 310C1123.73 310 1115 318.73 1115 329.5C1115 340.27 1123.73 349 1134.5 349Z",
    fill: "#999999"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1135,
    cy: 330,
    r: 4.5,
    stroke: "#999999",
    strokeWidth: 3
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1423,
    cy: 76,
    r: 76,
    fill: "#036551"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1437.69 100.325C1436.26 100.325 1435.1 99.1654 1435.1 97.7317V44.3749C1435.1 43.5821 1435.46 42.8323 1436.08 42.341C1436.7 41.8496 1437.51 41.6672 1438.29 41.8496C1440.39 42.346 1458.81 46.9889 1458.81 57.3918C1458.81 61.1659 1457.78 64.0155 1455.74 65.8595C1453.27 68.0961 1450.34 67.8782 1450.02 67.8403C1448.6 67.6959 1447.56 66.4269 1447.7 65.0008C1447.84 63.5773 1449.12 62.5666 1450.54 62.6781C1450.53 62.6755 1451.52 62.7186 1452.31 61.9714C1453.17 61.1532 1453.62 59.5701 1453.62 57.3918C1453.62 53.2732 1445.98 49.6511 1440.29 47.8045V97.7317C1440.29 99.1654 1439.12 100.325 1437.69 100.325Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1428.8 109.219C1422.47 109.219 1417.31 104.067 1417.31 97.7321C1417.31 91.3972 1422.47 86.2451 1428.8 86.2451C1435.13 86.2451 1440.29 91.3972 1440.29 97.7321C1440.29 104.067 1435.13 109.219 1428.8 109.219ZM1428.8 91.4326C1425.33 91.4326 1422.5 94.2594 1422.5 97.7321C1422.5 101.205 1425.33 104.032 1428.8 104.032C1432.27 104.032 1435.1 101.205 1435.1 97.7321C1435.1 94.2594 1432.27 91.4326 1428.8 91.4326Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1422.5 70.5908H1388.78C1387.35 70.5908 1386.19 69.4307 1386.19 67.9971C1386.19 66.5634 1387.35 65.4033 1388.78 65.4033H1422.5C1423.93 65.4033 1425.09 66.5634 1425.09 67.9971C1425.09 69.4307 1423.93 70.5908 1422.5 70.5908Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1414.74 85.5967H1388.78C1387.35 85.5967 1386.19 84.4366 1386.19 83.0029C1386.19 81.5693 1387.35 80.4092 1388.78 80.4092H1414.74C1416.17 80.4092 1417.33 81.5693 1417.33 83.0029C1417.33 84.4366 1416.17 85.5967 1414.74 85.5967Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1409.41 101.437H1388.78C1387.35 101.437 1386.19 100.277 1386.19 98.8437C1386.19 97.4101 1387.35 96.25 1388.78 96.25H1409.41C1410.84 96.25 1412 97.4101 1412 98.8437C1412 100.277 1410.84 101.437 1409.41 101.437Z",
    fill: "white"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dddddd_31_2308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1572.5 175V447C1572.5 448.933 1570.93 450.5 1569 450.5H1276C1274.07 450.5 1272.5 448.933 1272.5 447V175C1272.5 173.067 1274.07 171.5 1276 171.5H1405.96C1406.9 171.5 1407.82 171.202 1408.59 170.65L1420.45 162.093C1421.68 161.212 1423.32 161.212 1424.55 162.093L1436.41 170.65C1437.18 171.202 1438.1 171.5 1439.04 171.5H1569C1570.93 171.5 1572.5 173.067 1572.5 175Z",
    fill: "#23262D",
    stroke: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 206,
    width: 21.1794,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.43,
    y: 206,
    width: 79.9351,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1418.29,
    y: 206,
    width: 56.7061,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_31_2308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 335,
    width: 46.2595,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1357.68,
    y: 335,
    width: 140.321,
    height: 20,
    rx: 10,
    fill: "#404648"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1411.42,
    y: 393,
    width: 124.58,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 393,
    width: 100.763,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1272,
    y: 249,
    width: 301,
    height: 60,
    fill: "#C4C4C4",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296.74 295.263V286.772H1298.19C1298.68 286.381 1299.14 285.831 1299.57 285.121C1300 284.411 1300.36 283.437 1300.66 282.202C1300.95 280.966 1301.16 279.368 1301.27 277.408L1301.85 268.182H1315.79V286.772H1318.22V295.241H1314.43V290H1300.53V295.263H1296.74ZM1302.8 286.772H1312V271.495H1305.41L1305.07 277.408C1304.97 278.892 1304.82 280.22 1304.62 281.392C1304.41 282.564 1304.15 283.597 1303.84 284.492C1303.53 285.38 1303.18 286.14 1302.8 286.772ZM1328.41 290.32C1326.81 290.32 1325.43 289.968 1324.26 289.265C1323.08 288.562 1322.17 287.578 1321.53 286.314C1320.89 285.05 1320.57 283.572 1320.57 281.882C1320.57 280.192 1320.89 278.711 1321.53 277.44C1322.17 276.168 1323.08 275.181 1324.26 274.478C1325.43 273.775 1326.81 273.423 1328.41 273.423C1330.01 273.423 1331.39 273.775 1332.57 274.478C1333.74 275.181 1334.64 276.168 1335.28 277.44C1335.93 278.711 1336.25 280.192 1336.25 281.882C1336.25 283.572 1335.93 285.05 1335.28 286.314C1334.64 287.578 1333.74 288.562 1332.57 289.265C1331.39 289.968 1330.01 290.32 1328.41 290.32ZM1328.43 287.23C1329.3 287.23 1330.02 286.992 1330.6 286.516C1331.19 286.033 1331.62 285.387 1331.9 284.577C1332.2 283.768 1332.34 282.866 1332.34 281.871C1332.34 280.87 1332.2 279.964 1331.9 279.155C1331.62 278.338 1331.19 277.688 1330.6 277.205C1330.02 276.722 1329.3 276.481 1328.43 276.481C1327.54 276.481 1326.81 276.722 1326.22 277.205C1325.63 277.688 1325.2 278.338 1324.91 279.155C1324.62 279.964 1324.48 280.87 1324.48 281.871C1324.48 282.866 1324.62 283.768 1324.91 284.577C1325.2 285.387 1325.63 286.033 1326.22 286.516C1326.81 286.992 1327.54 287.23 1328.43 287.23ZM1352.64 267.585L1353.98 270.078C1353.51 270.49 1352.97 270.788 1352.38 270.973C1351.79 271.158 1351.1 271.278 1350.31 271.335C1349.52 271.385 1348.58 271.42 1347.49 271.442C1346.27 271.47 1345.27 271.701 1344.5 272.134C1343.73 272.567 1343.13 273.224 1342.72 274.105C1342.31 274.979 1342.04 276.094 1341.91 277.45H1342.09C1342.6 276.449 1343.32 275.685 1344.24 275.16C1345.17 274.634 1346.25 274.371 1347.49 274.371C1348.85 274.371 1350.05 274.677 1351.08 275.288C1352.13 275.891 1352.94 276.768 1353.52 277.919C1354.11 279.07 1354.41 280.462 1354.41 282.095C1354.41 283.778 1354.09 285.238 1353.46 286.474C1352.83 287.702 1351.93 288.651 1350.76 289.318C1349.61 289.986 1348.23 290.32 1346.64 290.32C1345.06 290.32 1343.68 289.975 1342.51 289.286C1341.34 288.59 1340.44 287.564 1339.8 286.207C1339.17 284.844 1338.85 283.164 1338.85 281.168V279.698C1338.85 275.849 1339.57 272.976 1341.01 271.08C1342.44 269.183 1344.57 268.217 1347.39 268.182C1348.22 268.168 1348.97 268.164 1349.63 268.171C1350.3 268.178 1350.88 268.146 1351.38 268.075C1351.88 268.004 1352.3 267.841 1352.64 267.585ZM1346.66 287.23C1347.45 287.23 1348.13 287.028 1348.71 286.623C1349.28 286.211 1349.72 285.629 1350.03 284.876C1350.34 284.123 1350.5 283.232 1350.5 282.202C1350.5 281.186 1350.34 280.323 1350.03 279.613C1349.72 278.896 1349.27 278.349 1348.7 277.972C1348.12 277.596 1347.44 277.408 1346.64 277.408C1346.04 277.408 1345.51 277.514 1345.03 277.727C1344.56 277.94 1344.15 278.253 1343.82 278.665C1343.48 279.077 1343.23 279.577 1343.05 280.167C1342.87 280.756 1342.78 281.435 1342.76 282.202C1342.76 283.743 1343.11 284.968 1343.81 285.877C1344.5 286.779 1345.45 287.23 1346.66 287.23ZM1362.4 290.33C1361.36 290.33 1360.43 290.146 1359.6 289.776C1358.77 289.4 1358.12 288.846 1357.64 288.114C1357.16 287.383 1356.92 286.481 1356.92 285.408C1356.92 284.485 1357.09 283.722 1357.43 283.118C1357.77 282.514 1358.24 282.031 1358.83 281.669C1359.42 281.307 1360.08 281.033 1360.82 280.849C1361.57 280.657 1362.34 280.518 1363.13 280.433C1364.09 280.334 1364.87 280.245 1365.47 280.167C1366.06 280.082 1366.5 279.954 1366.77 279.783C1367.04 279.606 1367.18 279.332 1367.18 278.963V278.899C1367.18 278.097 1366.94 277.475 1366.47 277.035C1365.99 276.594 1365.31 276.374 1364.41 276.374C1363.47 276.374 1362.72 276.58 1362.16 276.992C1361.62 277.404 1361.25 277.891 1361.06 278.452L1357.45 277.94C1357.74 276.946 1358.21 276.115 1358.86 275.447C1359.51 274.773 1360.31 274.268 1361.26 273.935C1362.2 273.594 1363.25 273.423 1364.39 273.423C1365.18 273.423 1365.96 273.516 1366.74 273.7C1367.53 273.885 1368.24 274.19 1368.89 274.616C1369.53 275.036 1370.05 275.607 1370.44 276.332C1370.84 277.056 1371.04 277.962 1371.04 279.048V290H1367.33V287.752H1367.2C1366.97 288.207 1366.64 288.633 1366.21 289.031C1365.79 289.421 1365.26 289.737 1364.62 289.979C1363.99 290.213 1363.25 290.33 1362.4 290.33ZM1363.4 287.496C1364.17 287.496 1364.84 287.344 1365.41 287.038C1365.98 286.726 1366.42 286.314 1366.72 285.803C1367.04 285.291 1367.19 284.734 1367.19 284.13V282.202C1367.07 282.301 1366.86 282.393 1366.57 282.479C1366.29 282.564 1365.97 282.638 1365.61 282.702C1365.26 282.766 1364.91 282.823 1364.56 282.873C1364.21 282.923 1363.91 282.965 1363.65 283.001C1363.08 283.079 1362.56 283.207 1362.11 283.384C1361.66 283.562 1361.3 283.81 1361.03 284.13C1360.77 284.442 1360.64 284.847 1360.64 285.344C1360.64 286.055 1360.9 286.591 1361.42 286.953C1361.94 287.315 1362.6 287.496 1363.4 287.496ZM1374.92 290V273.636H1381.79C1383.73 273.636 1385.26 274.023 1386.38 274.798C1387.51 275.572 1388.07 276.651 1388.07 278.036C1388.07 278.952 1387.75 279.702 1387.11 280.284C1386.48 280.859 1385.62 281.246 1384.52 281.445C1385.38 281.516 1386.14 281.733 1386.78 282.095C1387.44 282.457 1387.95 282.933 1388.32 283.523C1388.69 284.112 1388.87 284.79 1388.87 285.558C1388.87 286.46 1388.63 287.244 1388.16 287.912C1387.69 288.572 1387 289.087 1386.1 289.457C1385.21 289.819 1384.12 290 1382.84 290H1374.92ZM1378.53 286.964H1382.84C1383.55 286.964 1384.11 286.797 1384.51 286.463C1384.92 286.122 1385.12 285.661 1385.12 285.078C1385.12 284.403 1384.92 283.874 1384.51 283.491C1384.11 283.1 1383.55 282.905 1382.84 282.905H1378.53V286.964ZM1378.53 280.412H1381.86C1382.39 280.412 1382.84 280.337 1383.21 280.188C1383.59 280.032 1383.88 279.815 1384.08 279.538C1384.28 279.254 1384.38 278.917 1384.38 278.526C1384.38 277.965 1384.14 277.525 1383.68 277.205C1383.23 276.886 1382.6 276.726 1381.79 276.726H1378.53V280.412ZM1395.77 284.78L1402.32 273.636H1406.29V290H1402.56V278.846L1396.03 290H1392.05V273.636H1395.77V284.78ZM1408.41 276.8V273.636H1422.73V276.8H1417.44V290H1413.71V276.8H1408.41ZM1428.41 278.963H1433.24C1435.33 278.963 1436.94 279.471 1438.09 280.487C1439.23 281.502 1439.81 282.834 1439.81 284.482C1439.81 285.554 1439.54 286.506 1439.02 287.337C1438.51 288.168 1437.77 288.821 1436.79 289.297C1435.81 289.766 1434.63 290 1433.24 290H1425.8V273.636H1429.52V286.836H1433.24C1434.08 286.836 1434.77 286.623 1435.31 286.197C1435.85 285.763 1436.12 285.21 1436.12 284.535C1436.12 283.825 1435.85 283.246 1435.31 282.798C1434.77 282.351 1434.08 282.127 1433.24 282.127H1428.41V278.963ZM1450.56 290V273.636H1457.43C1459.37 273.636 1460.9 274.023 1462.02 274.798C1463.15 275.572 1463.72 276.651 1463.72 278.036C1463.72 278.952 1463.4 279.702 1462.76 280.284C1462.13 280.859 1461.26 281.246 1460.17 281.445C1461.03 281.516 1461.78 281.733 1462.43 282.095C1463.08 282.457 1463.59 282.933 1463.96 283.523C1464.33 284.112 1464.52 284.79 1464.52 285.558C1464.52 286.46 1464.28 287.244 1463.8 287.912C1463.33 288.572 1462.65 289.087 1461.75 289.457C1460.85 289.819 1459.76 290 1458.49 290H1450.56ZM1454.17 286.964H1458.49C1459.2 286.964 1459.75 286.797 1460.16 286.463C1460.56 286.122 1460.77 285.661 1460.77 285.078C1460.77 284.403 1460.56 283.874 1460.16 283.491C1459.75 283.1 1459.2 282.905 1458.49 282.905H1454.17V286.964ZM1454.17 280.412H1457.51C1458.03 280.412 1458.48 280.337 1458.86 280.188C1459.24 280.032 1459.52 279.815 1459.72 279.538C1459.92 279.254 1460.02 278.917 1460.02 278.526C1460.02 277.965 1459.79 277.525 1459.33 277.205C1458.87 276.886 1458.24 276.726 1457.43 276.726H1454.17V280.412ZM1484.56 285.515L1489.42 273.636H1492.53L1485.91 290H1483.22L1476.75 273.636H1479.83L1484.56 285.515ZM1478.86 273.636V290H1475.14V273.636H1478.86ZM1490.42 290V273.636H1494.1V290H1490.42ZM1501.71 284.78L1508.26 273.636H1512.22V290H1508.5V278.846L1501.97 290H1497.99V273.636H1501.71V284.78ZM1516.18 290V273.636H1520.04V280.241H1521.45L1526.37 273.636H1531.01L1524.95 281.669L1531.08 290H1526.41L1521.93 283.832H1520.04V290H1516.18ZM1539.73 290.32C1538.1 290.32 1536.69 289.961 1535.52 289.244C1534.36 288.526 1533.46 287.536 1532.83 286.271C1532.2 285 1531.89 283.537 1531.89 281.882C1531.89 280.22 1532.21 278.754 1532.85 277.482C1533.49 276.204 1534.39 275.21 1535.55 274.499C1536.72 273.782 1538.11 273.423 1539.71 273.423C1541.04 273.423 1542.21 273.668 1543.23 274.158C1544.26 274.641 1545.08 275.327 1545.69 276.214C1546.31 277.095 1546.65 278.125 1546.74 279.304H1543.05C1542.9 278.516 1542.55 277.859 1541.99 277.333C1541.43 276.8 1540.69 276.534 1539.76 276.534C1538.97 276.534 1538.28 276.747 1537.68 277.173C1537.09 277.592 1536.62 278.196 1536.29 278.984C1535.96 279.773 1535.8 280.717 1535.8 281.818C1535.8 282.933 1535.96 283.892 1536.29 284.695C1536.61 285.49 1537.07 286.104 1537.66 286.538C1538.26 286.964 1538.96 287.177 1539.76 287.177C1540.33 287.177 1540.84 287.07 1541.28 286.857C1541.74 286.637 1542.12 286.321 1542.42 285.909C1542.73 285.497 1542.94 284.996 1543.05 284.407H1546.74C1546.65 285.565 1546.31 286.591 1545.72 287.486C1545.13 288.374 1544.32 289.07 1543.31 289.574C1542.29 290.071 1541.1 290.32 1539.73 290.32Z",
    fill: "#35FFD0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_31_2308",
    x: 481,
    y: 533,
    width: 461,
    height: 471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.76726
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.1069
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0196802 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_2308"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.6501
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66004
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0282725 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_31_2308",
    result: "effect2_dropShadow_31_2308"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.5216
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.00862
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.035 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_31_2308",
    result: "effect3_dropShadow_31_2308"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22.3363
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.93452
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0417275 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_31_2308",
    result: "effect4_dropShadow_31_2308"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 41.7776
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.711
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0503198 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_31_2308",
    result: "effect5_dropShadow_31_2308"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 100
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_31_2308",
    result: "effect6_dropShadow_31_2308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_31_2308",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dddddd_31_2308",
    x: 1192,
    y: 160,
    width: 461,
    height: 471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.76726
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.1069
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0196802 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_2308"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.6501
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66004
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0282725 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_31_2308",
    result: "effect2_dropShadow_31_2308"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.5216
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.00862
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.035 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_31_2308",
    result: "effect3_dropShadow_31_2308"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22.3363
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.93452
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0417275 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_31_2308",
    result: "effect4_dropShadow_31_2308"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 41.7776
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.711
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0503198 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_31_2308",
    result: "effect5_dropShadow_31_2308"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 100
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_31_2308",
    result: "effect6_dropShadow_31_2308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_31_2308",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_2308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202,
    height: 20,
    fill: "white",
    transform: "translate(585 708)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_31_2308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262,
    height: 20,
    fill: "white",
    transform: "translate(93 108.774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_31_2308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262,
    height: 20,
    fill: "white",
    transform: "translate(600 108.774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_31_2308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262,
    height: 20,
    fill: "white",
    transform: "translate(600 227.774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_31_2308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262,
    height: 20,
    fill: "white",
    transform: "translate(600 346.774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_31_2308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262,
    height: 20,
    fill: "white",
    transform: "translate(600 465.774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_31_2308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 20,
    fill: "white",
    transform: "translate(718 95.7744)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_31_2308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 20,
    fill: "white",
    transform: "translate(718 129.774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_31_2308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 20,
    fill: "white",
    transform: "translate(718 275.774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_31_2308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 20,
    fill: "white",
    transform: "translate(718 309.774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_31_2308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 20,
    fill: "white",
    transform: "translate(718 455.774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_31_2308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 20,
    fill: "white",
    transform: "translate(718 489.774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_31_2308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202,
    height: 20,
    fill: "white",
    transform: "translate(1296 335)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroStateGraphRu);
export default __webpack_public_path__ + "static/media/zeroState-graph-ru.fae37b80.svg";
export { ForwardRef as ReactComponent };